module.exports = __webpack_public_path__ + "img/1.85aad6b3.webp";